import { useSelector } from 'react-redux';
import classNames from 'classnames';
import I18n from 'i18n-js';

import { useExplorationQuests } from '@lootboy/lib/hooks/useExplorationQuests';
import { loggedSelector } from '@lootboy/lib/selectors';
import { TStore } from '@lootboy/lib/types/store';

import { Divider } from '~/components/atoms/Divider';
import XIcon from '~/components/atoms/Icons/XIcon';
import { ListContainer } from '~/components/atoms/ListContainer';
import { useOpenScreenEvent } from '~/components/GoogleTagManager';
import Image from '~/components/Image';
import { ANIMATED_ROOT_POPUP_ID } from '~/components/molecules/BottomSheetDialog/utils';
import { CardPopupContainer } from '~/components/molecules/CardPopupContainer';

import { useClosePopup } from '~/hooks/useClosePopup';
import { useDocumentTitle } from '~/hooks/useDocumentTitle';
import { QuestTile } from '~/views/ExplorationQuestView/QuestTile';

import explorationQuestBackground from '~/assets/images/banners/exploration-quest-transparent.png';

import textStyles from '~/sass/typography.module.scss';

import styles from './ExplorationQuestView.module.scss';

export function ExplorationQuestView(): JSX.Element {
  const closePopup = useClosePopup();
  const quests = useExplorationQuests('web');
  const isLoggedIn = useSelector<TStore, boolean>(loggedSelector);

  useOpenScreenEvent('questwall');
  useDocumentTitle(I18n.t('OfferWall_banner_exploration_quests'));

  return (
    <CardPopupContainer
      className={styles.container}
      onClose={closePopup}
      contentElementId={ANIMATED_ROOT_POPUP_ID}
    >
      <XIcon
        onClick={closePopup}
        className={styles.closeButton}
      />
      <Image
        alt=""
        src={explorationQuestBackground}
        height={357}
        width={668}
        className={styles.headerImage}
        loading="eager"
      />
      <section
        className={classNames(textStyles.withTypography, styles.content)}
      >
        <h2 className={styles.header}>{I18n.t('QuestWallView_header_2')}</h2>
        <p className={styles.text}>{I18n.t('QuestWallView_intro')}</p>
        <Divider className={styles.divider} />
        <ListContainer>
          {quests.map((quest) => (
            <li key={quest._id}>
              <QuestTile
                quest={quest}
                isLoggedIn={isLoggedIn}
              />
            </li>
          ))}
        </ListContainer>
      </section>
    </CardPopupContainer>
  );
}
